import { html } from 'lit';

export function themeOnTracks() {
  return html`<div class="progress__item"></div>`;
}
